import React from 'react';

import { ContactLensWishIcon } from '../../components';
import './ContactLensHeaderTitle.scss';

export const ContactLensHeaderTitle = props => {
  const { mockData, productData } = props;

  const prices = productData?.prices || [];
  const findPrice = name => prices.find(p => p.name === name)?.price;

  const before = findPrice('Market Price');
  const after = findPrice('Sales Price') ?? findPrice('Lenskart Price');

  const data = productData
    ? {
        title: productData.title,
        subTitle: productData.brandName,
        description: {
          title: productData.description,
          price: { before, after },
        },
        bestOffer: {
          discount: before && after ? Math.round(((before - after) / before) * 100) : 0,
        },
      }
    : mockData;

  const { title, subTitle, description, bestOffer } = data;

  return (
    <div className="contact-lens-header-title__container">
      <h1 className="contact-lens-header-title__title">
        <strong>{title}</strong>
        <small>{subTitle}</small>
        <div className="contact-lens-header-title__icon-heart">
          <ContactLensWishIcon />
        </div>
      </h1>

      <div className="contact-lens-header-title__price">
        <p className="contact-lens-header-title__price-desc">{description.title}</p>

        <div className="contact-lens-header-title__price-container">
          {bestOffer.discount > 0 && description.price.before && (
            <div className="contact-lens-header-title__price-before">
              <span>S${description.price.before}</span>
            </div>
          )}

          <div className="contact-lens-header-title__price-after">
            <span>S${description.price.after}</span>
          </div>
        </div>
      </div>

      {bestOffer.discount > 0 && (
        <div className="contact-lens-header-title__best-offer">
          <p className="contact-lens-header-title__best-offer-title">Best offer for you</p>
          <p className="contact-lens-header-title__best-offer-discount">
            Get {bestOffer.discount} off second pair
          </p>
        </div>
      )}
    </div>
  );
};
